<script setup lang="ts">
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  coordinateCount: number;
}
const props = defineProps<Props>();
const { coordinateCount } = toRefs(props);
const { t } = useI18n();
</script>

<template>
  <div class="w-full flex items-center justify-center text-center py-8">
    <div class="max-w-[240px] p-2 text-light-label-secondary dark:text-primary-300">
      <p class="font-bold">
        {{ t('drawTools.route.notEnoughCoordinatesTitle', coordinateCount) }}
      </p>
      <p class="">
        {{
          t('drawTools.route.notEnoughCoordinatesDescription', coordinateCount)
        }}
      </p>
    </div>
  </div>
</template>
